import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Le password non coincidono");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password: pw });
      localStorage.setItem("enbissy_token", data.token);
      setUser(data.user);
      toast.success("Password aggiornata");
      navigate("/feed", { replace: true });
    } catch (err) { toast.error(apiError(err.response?.data?.detail) || "Errore"); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="reset-password-page" className="min-h-screen bg-white text-[#0a0a0a]">
      <header className="px-6 py-5 flex items-center justify-between max-w-md mx-auto"><a href="/"><Logo /></a><a href="/" className="text-sm underline">Torna alla home</a></header>
      <main className="max-w-md mx-auto px-6 pb-20">
        <h1 className="font-display text-3xl font-extrabold mb-1">Scegli una nuova password</h1>
        <p className="text-neutral-500 mb-6 text-sm">Il link vale 1 ora e si usa una sola volta.</p>
        {!token ? (
          <p data-testid="reset-no-token" className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-xl p-3">Link non valido. <a href="/" className="underline">Richiedi un nuovo reset</a>.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 rounded-3xl border border-neutral-200 p-6">
            <div><Label className="text-xs">Nuova password</Label><Input data-testid="reset-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={6} className="mt-1 h-11" /></div>
            <div><Label className="text-xs">Ripeti password</Label><Input data-testid="reset-password-2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required minLength={6} className="mt-1 h-11" /></div>
            <Button data-testid="reset-submit" type="submit" disabled={busy} className="w-full h-12 rounded-full bg-black text-white">{busy ? "…" : "Salva e accedi"}</Button>
          </form>
        )}
      </main>
    </div>
  );
}
